module.exports = __webpack_public_path__ + "img/ZHWLRJKF_4.956201b9.jpg";